<template>
  <main>
    <HeroSection title="O nas" subtitle="Poznaj VI-GAS" />
    <AboutSection />
  </main>
</template>

<script>
import HeroSection from '../components/HeroSection.vue'
import AboutSection from '../components/AboutSection.vue'

export default {
  name: 'AboutPage',
  components: {
    HeroSection,
    AboutSection
  }
}
</script>
